import { UnitCurrentStatus, UnitsSource } from "api/units";

export interface UnitsFilters {
  states: string[];
  cities: string[];
  property_group_ids: number[];
  property_ids: number[];
  unit_ids: number[];
  current_statuses: UnitCurrentStatus[];
  owner_ids: number[];
  sources: UnitsSource[];
  needs_lockbox: boolean;
}

export const EMPTY_UNITS_FILTERS: UnitsFilters = {
  states: [],
  cities: [],
  property_group_ids: [],
  property_ids: [],
  unit_ids: [],
  current_statuses: [],
  owner_ids: [],
  sources: [],
  needs_lockbox: false
};

export const countActiveUnitsFilters = ({
  needs_lockbox,
  ...listFilters
}: UnitsFilters) =>
  Object.values(listFilters).reduce(
    (total, values) => total + values.length,
    needs_lockbox ? 1 : 0
  );
